import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import MdmStripe from '~/components/atoms/Global/MdmStripe.vue';
import SalesDecoration from './SalesDecoration.vue';
import NoveltyDecoration from './NoveltyDecoration.vue';
import SpecialEventDecoration from './SpecialEventDecoration.vue';
import TrendDecoration from './TrendDecoration.vue';
export default {
  name: 'StripesDecoration',
  components: {
    SalesDecoration,
    NoveltyDecoration,
    SpecialEventDecoration,
    TrendDecoration,
    MdmStripe
  },
  props: {
    sales: {
      type: Object,
      required: true
    },
    novelty: {
      type: Boolean,
      required: true
    },
    special: {
      type: Object,
      required: true
    },
    trends: {
      type: Object,
      required: true
    }
  },
  computed: {
    salesPredicate() {
      return this.sales && this.sales.sales_amount;
    },

    specialEventPredicate() {
      return Object.keys(this.special).length > 0;
    },

    trendPredicate() {
      return Object.keys(this.trends).length > 0;
    },

    firstStripe() {
      let component = null;

      if (this.novelty) {
        component = 'NoveltyDecoration';
      }

      if (this.offerPredicate) {
        component = 'OfferDecoration';
      }

      if (this.salesPredicate) {
        component = 'SalesDecoration';
      }

      return component;
    },

    secondStripe() {
      let component = null;

      if (this.trendPredicate) {
        component = 'TrendDecoration';
      }

      if (this.specialEventPredicate) {
        component = 'SpecialEventDecoration';
      }

      return component;
    }

  }
};